import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "children", "className", "css", "iconLeft", "iconRight", "size", "style", "variant", "isLoading", "color", "spinnerColor", "shortcut", "shortcutsVariant"];
import React from "react";
import Shortcuts from "../../Shortcuts";
import Spinner from "../../Spinner";
import { ButtonIcon } from "../components/ButtonIcon";
import { BaseButton, BaseContentContainer, BaseLoadingContainer } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ButtonPrimitive = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    children = _ref.children,
    className = _ref.className,
    css = _ref.css,
    iconLeft = _ref.iconLeft,
    iconRight = _ref.iconRight,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "default" : _ref$size,
    style = _ref.style,
    variant = _ref.variant,
    isLoading = _ref.isLoading,
    color = _ref.color,
    spinnerColor = _ref.spinnerColor,
    shortcut = _ref.shortcut,
    shortcutsVariant = _ref.shortcutsVariant,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(BaseButton, _extends({
    ref: ref,
    size: size,
    isLoading: isLoading,
    color: color,
    variant: variant,
    hasShortcut: !!shortcut
  }, restProps, {
    children: [/*#__PURE__*/_jsxs(BaseContentContainer, {
      isLoading: isLoading,
      children: [iconLeft && /*#__PURE__*/_jsx(ButtonIcon, {
        spacing: "end",
        size: size,
        children: iconLeft
      }), children, shortcut && /*#__PURE__*/_jsx(Shortcuts, {
        keys: shortcut,
        variant: shortcutsVariant,
        color: color,
        combineKeys: true
      }), iconRight && /*#__PURE__*/_jsx(ButtonIcon, {
        spacing: "start",
        size: size,
        children: iconRight
      })]
    }), isLoading && /*#__PURE__*/_jsx(BaseLoadingContainer, {
      css: {
        lineHeight: 1
      },
      children: /*#__PURE__*/_jsx(Spinner, {
        size: size === "compact" ? "sm" : "md",
        onBackgroundColor: spinnerColor
      })
    })]
  }));
});
ButtonPrimitive.displayName = "ButtonPrimitive";
export default ButtonPrimitive;